/**
 * Confirmation Directive 
 * shows a confirmation modal with a given message before triggering the callback function
 * callback function is triggered with boolean positive or negative value
 * 
 * Example:
 *   <b-button v-confirm="{ message: 'Are you sure you want to do it?', callback: (result) => { ... } }">Delete</b-button>
 */
import Vue from 'vue'

Vue.directive('confirm', {
  bind: function (el, binding, vnode) {
    el.addEventListener('click', () => {
      vnode.context.$bvModal.msgBoxConfirm(binding.value && binding.value.message || 'Are you sure?', {
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'Cancel',
        centered: true,
      })
      .then(value => {
        if ( value && !!binding.value.callback ) {
          binding.value.callback.call( vnode.fnContext, value );
        }
      });
    })
  }
})